import React from 'react';
import { BoostersBlockersHealthCard } from '@design-system/Cards/BoostersBlockersHealthCard';
import { BoosterAndBlockerSummaryResponse } from '@viome/viome-base/src/usecase/Health/Health.model';
import { useNavigate } from 'react-router-dom';
import { Render } from '@/components/Helpers/ComponentRender/Render';
import { EventTracker } from '@/utils';

interface ImproveHealthSectionProps {
  scoreName: string;
  boosters?: BoosterAndBlockerSummaryResponse;
  scoreId: number;
  'data-testid'?: string;
}

export const ImproveHealthSection: React.FC<ImproveHealthSectionProps> = ({
  scoreName,
  boosters,
  scoreId,
  'data-testid': testId,
}) => {
  const navigate = useNavigate();
  if (!boosters) return null;

  // TODO: FIX API description is dynamic
  const { image_url, count } = boosters;

  return (
    <Render when={count > 0}>
      <div className="mt-12" data-testid={testId}>
        <h2 className="dark typography-h1 text-primary mb-2" data-testid="healthL2Details-improveTitle">
          Improve Your {scoreName}
        </h2>
        <p className="dark typography-body text-secondary mb-6 lg:w-[35rem]" data-testid="healthL2Details-improveDescription">
          Dive deep into the underlying microbial functions and pathways that
          contribute to this Health Zone.
        </p>
        <BoostersBlockersHealthCard
          description="Explore the foods and ingredients we've identified as boosters and blockers for this Health Zone, each backed by research to support your needs."
          images={image_url}
          count={count}
          onClick={() => {
            EventTracker.trackEvent(
              'health',
              `${scoreName.replace(/\s+/g, '')}_boostersBlockers`,
            );
            navigate(`/boosters-and-blockers/${scoreId}`);
          }}
        />
      </div>
    </Render>
  );
};
